export class FeatureFlags {
  // Pro umozneni koordinatorum pridavat asistence do minulosti behem testovaciho obdobi
  static allowCreatingAssistancesInThePastXdays = false

  // Child asistence
  static childAssistances = true

  // AssistanceEditor: kdyz upravim cas od, upravi se o stejny cas i cas do
  static assistanceEditor_adaptiveTimeTo = true

  static assistanceEditor_autosave = false
  static assistanceEditor_allowJournalEntryEditor = true

  // AssistanceList - implicitni filtrovani na pracovni skupinu daneho koordinatora pri inicializaci seznamu asistenci
  static assistanceList_defaultWorkgroupFilter = false

  static assistantSelect_showAssistancesAround = true

  static availabilities_assistanceAvailabilityFiller = true
  static assistants_allowDeactivate = true
  static clients_allowDeactivate = true

  static subresourcesPolyfill = true

  static assistanceCalendar_seriesDragAndDrop = false

  static showUnavailableWorkersWarningInSR = false

  static displayNewWorkerMonthlyAttendanceReport = true
}
